import {Apollo} from 'apollo-angular';

import { Injectable } from '@angular/core';
import { KeepAliveGQL, KeepAliveSubscription } from '../graphql';

import { map } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class KeepAliveService {

    constructor(
        private apollo: Apollo,
        private keepAliveGQL: KeepAliveGQL
    ) {}

    public startKeepAlive() {
        return this.apollo.use('v2_ws').subscribe({
            query: this.keepAliveGQL.document,
            fetchPolicy: 'network-only'
        }).pipe(map((e: Apollo.QueryResult<KeepAliveSubscription>) => {
            return e.data.KEEP_ALIVE;
        }));
    }
}
